import styled, {css} from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {mobileOnly} from '../../../../constants/customMedia';

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const BasketSection = styled.div`
  ${mobileOnly(
    css`
      background: ${COLORS.White};
      border-bottom: 8px solid ${COLORS.Grey4};
    `,
  )}
`;
